<script context="module" lang="ts">
  declare var YT: any;
</script>

<script lang="ts">
  import LibLoader from './Util/LibLoader.svelte';
  export let video_url: string;
  export let video_name: string;
  export let video_channel: string;
  export let start_seconds: Number = 0;
  
  
  // From https://github.com/radiovisual/get-video-id
  /**
  * Strip away any parameters following `?` or `/` or '&'
  * @param str
  * @returns {String}
  */
  function stripParameters(str) {
    // Split parameters or split folder separator
    if (str.indexOf('?') > -1) {
      return str.split('?')[0];
    } else if (str.indexOf('/') > -1) {
      return str.split('/')[0];
    } else if (str.indexOf('&') > -1) {
      return str.split('&')[0];
    }
    return str;
  }
  /**
  * Get the Youtube Video id.
  * @param {string} str - the url from which you want to extract the id
  * @returns {string|undefined}
  */
  function getYoutubeId(str) {
    // remove time hash at the end of the string
    str = str.replace(/#t=.*$/, '');
    
    // shortcode
    var shortcode = /youtube:\/\/|https?:\/\/youtu\.be\/|http:\/\/y2u\.be\//g;
    
    if (shortcode.test(str)) {
      var shortcodeid = str.split(shortcode)[1];
      return stripParameters(shortcodeid);
    }
    
    // /v/ or /vi/
    var inlinev = /\/v\/|\/vi\//g;
    
    if (inlinev.test(str)) {
      var inlineid = str.split(inlinev)[1];
      return stripParameters(inlineid);
    }
    
    // v= or vi=
    var parameterv = /v=|vi=/g;
    
    if (parameterv.test(str)) {
      var arr = str.split(parameterv);
      return stripParameters(arr[1].split('&')[0]);
    }
    
    // v= or vi=
    var parameterwebp = /\/an_webp\//g;
    
    if (parameterwebp.test(str)) {
      var webp = str.split(parameterwebp)[1];
      return stripParameters(webp);
    }
    
    // embed
    var embedreg = /\/embed\//g;
    
    if (embedreg.test(str)) {
      var embedid = str.split(embedreg)[1];
      return stripParameters(embedid);
    }
    
    // ignore /user/username pattern
    var usernamereg = /\/user\/([a-zA-Z0-9]*)$/g;
    
    if (usernamereg.test(str)) {
      return undefined;
    }
    
    // user
    var userreg = /\/user\/(?!.*videos)/g;
    
    if (userreg.test(str)) {
      var elements = str.split('/');
      return stripParameters(elements.pop());
    }
    
    // attribution_link
    var attrreg = /\/attribution_link\?.*v%3D([^%&]*)(%26|&|$)/;
    
    if (attrreg.test(str)) {
      return stripParameters(str.match(attrreg)[1]);
    }
  }
  function getYoutubePlaylist(str) {
    // Playlist
    var parameterlist = /list=/g;
    if (parameterlist.test(str)) {
      var arr = str.split(parameterlist);
      return stripParameters(arr[1].split('&')[0]);
    }
  }
  
  export let video_id;
  $: video_id = video_url == null || video_url.length == 0 ? null : getYoutubeId(video_url) ?? video_url;
  $: playlist_id = video_url == null || video_url.length == 0 ? null : getYoutubePlaylist(video_url) ?? null;
  
  let prev_id = null;
  function cueVideo(id, start) {
    if (is_playing && id == prev_id) {
      if (start > 0) {
        player.seekTo(start, true);
      }
    } else {
      prev_id = id;
      player.cueVideoById(id, start);
      //player.loadVideoById(id, start);
    }
  }

  $: if(player_ready) {
      if (playlist_id != null) {
        player.cuePlaylist({
          listType: "playlist",
          list: playlist_id,
          index: 0,
          startSeconds: start_seconds
        });
      } else if (video_id != null) {
        cueVideo(video_id, start_seconds);
      } 
  }
  
  let player;
  let player_ready = false;
  function onPlayerReady(event){
    player_ready = true;
    window.yt = player;
  }
  let is_playing = false;

  let video_data = {};
  $: if (video_data.title != null) video_name = video_data.title;
  $: if (video_data.author_url != null) video_channel = video_data.author_url;
  function onPlayerStateChange(event){
    is_playing = event.data != -1 && event.data != YT.PlayerState.CUED;

    // Get video title from oembed endpoint.
    window.fetch(`https://www.youtube.com/oembed?type=json&url=${player.playerInfo.videoUrl}`)
      .then(r=>r.json())
      .then(data=>{
        video_data = data;
      })
  }
  function doLoadPlayer(event) {
    if(player != null || YT.Player == null) return;
    player = new YT.Player('ytframe', {
      //height: '390',
      //width: '640',
      //videoId: video_id,
      host: "https://www.youtube.com",
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });

  }
  window.onYouTubeIframeAPIReady = doLoadPlayer;
  
</script>
<container>
  {#if video_data.title}
    <h4 class="w500">
      {video_data.title}
      {#if video_data.author_name}
       - {video_data.author_name}
       {/if}

    </h4>
  {/if}
<div style={video_id != null ? "background: black;" : ""}>
  <div style={video_id == null ? "visibility: hidden;" : ""} id="ytframe"/>
</div>
<LibLoader url="https://www.youtube.com/iframe_api" on:loaded={doLoadPlayer}/>
</container>

<style lang="scss">
  div {
    position: relative;
    width: 100%;
    height: 0;

    // A trick to make vertical padding a proportion of the width,
    // so the width/height aspect ratio of the YouTube video is fixed.
    padding-bottom: 56.25%;
    > #ytframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

    }
  }

</style>
